import { DatePicker, Form, Input } from 'antd';
import React, { PureComponent } from 'react';
import { API_DATE_FS, NON_ALPHA_NUM_RE } from './shared';

export class WaWwcFormItems extends PureComponent {
  static slug = 'wawwc'

  static identLabel = 'Card number'

  static placeholder = '1234567'


  static getSubmissionData(checkData, constituent) {
    const data = {
      fullName: constituent.get('fullName'),
      alternateName: constituent.get('alternateName'),
    };

    if (checkData.expiry) data.expiry = checkData.expiry.format(API_DATE_FS);
    return data;
  }

  static regNumberGetValueFromEvent(evt) {
    return evt.target.value.replace(NON_ALPHA_NUM_RE, '');
  }

  static disabledDate(current) {
    return current && current.valueOf() < Date.now();
  }

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;

    const {
      slug, identLabel, placeholder,
      regNumberGetValueFromEvent,
    } = this.constructor;

    const klass = this.constructor;

    const now = new Date();
    const nowDate = now.getDate().toString();
    const nowMonth = now.getMonth().toString();
    const strNowDate = nowDate.length === 1 ? `0${nowDate}` : nowDate;
    const strNowMonth = nowMonth.length === 1 ? `0${nowMonth}` : nowMonth;

    const datePlaceholder = `${strNowDate}-${strNowMonth}-${now.getFullYear()}`;

    return (<div>
      <Form.Item label={identLabel}>
        {getFieldDecorator(`${slug}.identifier`, {
          getValueFromEvent: regNumberGetValueFromEvent,
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${identLabel} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={disabled}
            placeholder={ placeholder }
          />,
        )
        }
      </Form.Item>
      <Form.Item label="Expiry">
        {getFieldDecorator(`${slug}.expiry`, {
          rules: [
            ...(rules || []),
          ],
        })(
          <DatePicker
            format="DD-MM-YYYY"
            placeholder={datePlaceholder}
            disabled={disabled}
            disabledDate={klass.disabledDate}
          />,
        )}
      </Form.Item>
    </div>);
  }
}
